import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getDashboardDetails = async ({ companyCode, locationCode, fromDate, toDate }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.NewDashBoard}?CompanyCode=${companyCode}&LocationCode=${locationCode}&FromDate=${fromDate}&ToDate=${toDate}`,
  );
  return data;
};

const getAllCompaniesDashboardDetails = async ({
  selectedCompanyCode,
  locationCode,
  userId,
  fromDate, toDate
}) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.AllCompanies_DashBoard}?CompanyCode=${selectedCompanyCode}&LocationCode=${locationCode}&UserId=${userId}&FromDate=${fromDate}&ToDate=${toDate}`,
  );
  return data;
};

export const useGetDashboardDetailsQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);

  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_DashBoard
        : Api_EndPoints.NewDashBoard,
      input, // important to avoid stale cache
    ],
    queryFn: () =>
      isAllCompanies
        ? getAllCompaniesDashboardDetails(input)
        : getDashboardDetails(input),
    refetchOnWindowFocus: true,
    enabled: !!input, // optional safety
  });
};

const getAttendanceChart = async ({ companyCode, locationCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.AttendanceDashboard}?CompanyCode=${companyCode}&LocationCode=${locationCode}`,
  );
  return data;
};

export const useGetAttendanceChartQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.AttendanceDashboard],
    queryFn: () => getAttendanceChart(companyCode),
  });
};
